import * as moment from 'moment';
import {
    IKN15ParseService,
    IParsedKN15Telegram
} from './kn15-telegram/kn15-parse.service';
import {
    IOperationalInputService,
    IWaterLevelTrendResponse
} from './input.service';
import {IStation} from '../../api/api.types';
import {OnChanges, IChangeIndication} from '../../common/common.types';
import {IStationApi} from '../../api/station-api.service';
import {IWaterLevelCardData} from './kn15-telegram/water-level-card.controller';
import {ITemperatureCardData} from './kn15-telegram/temperature-card.controller';
import {IDischargeCardData} from './kn15-telegram/discharge-card.controller';
import {IMeteoCardData} from './kn15-telegram/meteo-card.controller';
import {IImomoErrorService} from '../../error/error.service';
import {IIcePhenomenaCardData} from './kn15-telegram/ice-phenomena-card.component';
import {StateService} from 'angular-ui-router';
import {Stack} from 'immutable';
import {IInputEvents} from './input.controller'


export interface IParsedTelegramData {
  telegramText: string,
  station: IStation, //Station data corresponding to the telegram.
  overriddenDate: Date,
  overrideDate: boolean,
  waterLevelData: IWaterLevelCardData, //Displayed water level parsed from the telegram.
  dischargeData: IDischargeCardData,
  icePhenomenaCardData: IIcePhenomenaCardData, //Displayed ice phenomena.
  temperatureData: ITemperatureCardData, //Displayed temperature parsed from the telegram.
  meteoData: IMeteoCardData,
  isHqAdjustmentEnabled: boolean
}

export default class OperationalInputTelegramController implements OnChanges {
  static $inject = ['kn15ParseService', 'operationalInputService', 'stationApi', '$q', '$log', 
  'imomoErrorService', '$mdDialog', '$translate', '$state', '$timeout', '$rootScope'];

  /**
   * Whether processing of a telegram is in progress.
   */
  processingInProgress: boolean;

  /**
   * Callback indicating that the telegram text has been parsed successfully.
   */
  onProcessed: (callbackArgs: {
    parsedTelegramDataCollection: IParsedTelegramData[],
    unprocessedTelegrams: string[]
  }) => void;
  /**
   * The controller for the telegram form.
   */
  telegramForm: ng.IFormController;

  dischargeStationsWithMissingDataForToday: IStation[];
  meteoStationsWithMissingDataForToday: IStation[];

  /**
   * Telegrams text.
   */
  private telegrams: string;

  private unprocessedTelegrams: string[] = [];
  private paramsTelegrams: string[];
  private parsedTelegram: IParsedKN15Telegram;
  private parsedTelegramDataCollection: IParsedTelegramData[] = [];
  private stationAndTrendDataPromises: ng.IPromise<any>[] = [];
  private telegramsBackendErrorMessages: string[] = [];
  private telegramsMeteoWarningMessages: string[] = [];

  constructor(private kn15ParseService: IKN15ParseService,
              private operationalInputService: IOperationalInputService,
              private stationApi: IStationApi,
              private $q: ng.IQService,
              private $log: ng.ILogService,
              private imomoErrorService: IImomoErrorService,
              private $mdDialog:ng.material.IDialogService,
              private $translate:ng.translate.ITranslateService,
              private $state:StateService,
              private $timeout: ng.ITimeoutService,
              private $rootScope: ng.IRootScopeService
              ) {

    this.loadSitesWithoutTelegramForToday();

    this.$rootScope.$on(IInputEvents.INPUT_SUBMITTED, () => {
      this.loadSitesWithoutTelegramForToday();
    });

    if (this.paramsTelegrams) {
      this.unprocessedTelegrams = this.paramsTelegrams;
      this.processTelegrams();
    }

    $timeout(() => {
      let initialTelegramInput = document.getElementById('bulk-telegram-input');
      initialTelegramInput.focus();

      //enable only the paste event
      initialTelegramInput.addEventListener('keypress', function(evt) { 
        const theEvent = evt;
        const regex = /[]|\./;
        let key: string | number = theEvent.keyCode || theEvent.which;
            key = String.fromCharCode(key);
        if(!regex.test(key)) {
            theEvent.returnValue = false;
            if(theEvent.preventDefault) theEvent.preventDefault();
        }
      })
    })

  }

  /**
   * Hook that processes changes in the one-directional bindings.
   */
  $onChanges(changes: IChangeIndication) {
    // this.resetView();
    if(changes.hasOwnProperty('paramsTelegrams')) {
      this.unprocessedTelegrams = changes['paramsTelegrams'].currentValue;
    }
    
    this.onChanges();
  }

  $postLink() {
    this.$log.debug('Post link called.');
    angular.forEach(this.unprocessedTelegrams, (telegramText, index) => {
      this.displayError(index);
    });
  }

  private loadSitesWithoutTelegramForToday() {
    const currentDate = moment();

    this.$q.all([
      this.stationApi.getDischargeStationsWithTelegramByDate(currentDate, false),
      this.stationApi.getMeteoStationsWithTelegramByDate(currentDate, false)
    ])
    .then(([dischargeStations, meteoStations]) => {
      this.dischargeStationsWithMissingDataForToday = dischargeStations[0].sites;
      this.meteoStationsWithMissingDataForToday = meteoStations[0].sites;
    })
  }

  private resetView() {
    this.parsedTelegramDataCollection = [];
    this.stationAndTrendDataPromises = [];
    this.telegramsBackendErrorMessages = [];
    this.telegramsMeteoWarningMessages = [];
  }

  private onChanges() {
    //this.notifyChanges();
    if (this.telegrams) {
      this.processTelegrams();
    }  else {
      if (this.telegramForm) {
        this.telegramForm.$setUntouched();
        this.telegramForm.$setPristine();
      }
    }
  }

  onProcessButtonClick() {
    this.parsedTelegramDataCollection = [];
    //this.notifyChanges();
    this.processTelegrams();
  }

  private processTelegrams() {
    this.stationAndTrendDataPromises = [];
    this.parsedTelegramDataCollection = [];
    this.telegramsBackendErrorMessages = [];
    angular.forEach(this.unprocessedTelegrams, (telegramText, index) => {
      this.processTelegram(telegramText, index);
    });
  }

  /**
   * Processes the telegram text input and builds the parsed data views.
   */
  private processTelegram(telegramText?: string, index?: number) {
    const self = this;

    self.processingInProgress = true;
    let parsedTelegram:IParsedKN15Telegram = null;
    let overrideDate: boolean = null;
    let isMeteoStationDataOnly: boolean;

    try {
      parsedTelegram = self.kn15ParseService.parse(telegramText);
    } catch (error) {
      self.displayError(index);
      self.processingInProgress = false;
      return;
    }

    const dischargeStationPromise = 
      isMeteostationDataOnly(parsedTelegram) ? null : 
      this.stationApi.getDischargeStation({
        stationCode: parsedTelegram.sectionZero.stationCode
      });

    if (parsedTelegram.sectionZero) {
      this.telegramsBackendErrorMessages.push('');

      const trendDataPromise = parsedTelegram.sectionOne ? self.operationalInputService.verifyWaterTrend(
          parsedTelegram.sectionZero.date,
          parsedTelegram.sectionZero.stationCode,
          parsedTelegram.sectionOne.waterLevelAtEight,
          parsedTelegram.sectionOne.waterLevelTrend) : null;

      this.stationAndTrendDataPromises.push(
        self.$q.all([dischargeStationPromise, trendDataPromise, parsedTelegram, overrideDate])
          .catch((error: ng.IHttpPromiseCallbackArg<any>) => {
                errorHandling(error);
                self.processingInProgress = false;
            })
      );

      // last iteration
      if ( 
        (index || index === 0) && 
        index === (this.unprocessedTelegrams.length - 1)
      ) {
        self.$q.all(this.stationAndTrendDataPromises)
          .then((values) => {
            // value of failed promise is 'undefined' and we want to continue the process only if 
            // there is a station for every telegram's station code

            if (values.indexOf(undefined) === -1) {
              let promises:ng.IPromise<any>[] = []
              values.forEach(([dischargeStation, trendResponse, parsedTelegram, overrideDate]:[IStation, IWaterLevelTrendResponse|null, IParsedKN15Telegram, boolean], promiseIndex: number) => {
                const deferred = self.$q.defer<any>();
                if (parsedTelegram.sectionEight) {
                  const meteostationPromise = this.stationApi.getMeteoStation({
                    stationCode: parsedTelegram.sectionZero.stationCode
                  })
                  .then(meteoStation => {
                    parsedTelegram.sectionEight.siteId = meteoStation.id;
                    self.telegramsMeteoWarningMessages[promiseIndex] = '';
                    let station = isMeteostationDataOnly(parsedTelegram) ? meteoStation : dischargeStation;
                    deferred.resolve([parsedTelegram, station, trendResponse, overrideDate, promiseIndex]);
                  })
                  .catch(errorData => {
                    const stationCode = parsedTelegram.sectionZero.stationCode;
                    self.telegramsMeteoWarningMessages[promiseIndex] = 
                      self.$translate.instant('NO_METEOSTATION_FOR_CODE_EXTENDED', {stationCode});
                    if (isMeteostationDataOnly(parsedTelegram)) {
                      deferred.resolve()
                      this.processingInProgress = false;
                    } else {
                      deferred.resolve([parsedTelegram, dischargeStation, trendResponse, overrideDate, promiseIndex]);  
                    }
                  });  
                } else {
                  deferred.resolve([parsedTelegram, dischargeStation, trendResponse, overrideDate, promiseIndex]);
                }

                promises.push(deferred.promise)
              })

              self.$q.all(promises)
                .then((values) => {
                  values.forEach(([parsedTelegram, station, trendResponse, overrideDate, promiseIndex]) => {
                    self.onStationTrendDataLoaded(parsedTelegram, station, trendResponse, overrideDate, promiseIndex); 
                    self.processingInProgress = false;
                  });
                });
            }
            
          }).catch((error: ng.IHttpPromiseCallbackArg<any>) => {
            errorHandling(error);
            self.processingInProgress = false;
        });
       }
    } else {
      dischargeStationPromise.then((station: IStation) => {
        self.notifyChanges();
        self.processingInProgress = false;
      }).catch((error: ng.IHttpPromiseCallbackArg<any>)=> {
        errorHandling(error);
        self.processingInProgress = false;
      })
    }

    function errorHandling(error: ng.IHttpPromiseCallbackArg<any>) {
      const stationCode = parsedTelegram.sectionZero.stationCode;
      if (error.status == 400 || error.status == 404) { 
        // self.imomoErrorService.showMissingStationErrorDialog(
        //     parsedTelegram.sectionZero.stationCode);
        self.telegramForm['telegram' + index].$setValidity('backendError', false);
        self.telegramsBackendErrorMessages[index] = self.$translate.instant('NON_EXISTENT_STATION_CODE_EXTENDED', {stationCode});
        self.telegramForm['telegram' + index].$setDirty();
        self.telegramForm['telegram' + index].$setTouched();
      } else if (error.status == 403) {
        self.imomoErrorService.showForbiddenStationErrorDialog(stationCode);
      } else {
        self.imomoErrorService.showGenericErrorDialog();
      }
    }

    function isMeteostationDataOnly(parsedTelegram: IParsedKN15Telegram) {
      return parsedTelegram && 
             Stack(parsedTelegram.telegramText.trim().split(/\s+/)).get(1).indexOf('988') != -1;
    }
  } 

  // backend error message is displayed only after process button is pressed
  // so if there is a missing station error and user enters new code
  // message will still be present
  // this removes old message to prevent confusion
  private onIndividualTelegramInputChange($index: number) {
    this.telegramsBackendErrorMessages[$index] = '';
    this.telegramForm['telegram' + $index].$setValidity('backendError', true);
  }

  private onStationTrendDataLoaded(parsedTelegram: IParsedKN15Telegram,
                                   station: IStation,
                                   trendResponse: IWaterLevelTrendResponse,
                                   overrideDate: boolean,
                                   promiseIndex: number) {
    let parsedTelegramData: IParsedTelegramData = {
      telegramText: parsedTelegram.telegramText,
      station: null,
      overriddenDate: null,
      overrideDate: overrideDate,
      waterLevelData: null,
      dischargeData: null,
      icePhenomenaCardData: null,
      temperatureData: null,
      meteoData: null,
      isHqAdjustmentEnabled: 
        parsedTelegram.sectionOne && parsedTelegram.sectionSix ? true : false
    };
    parsedTelegramData.station = station;
    parsedTelegramData.overriddenDate = parsedTelegram.sectionZero.date && parsedTelegram.sectionZero.date.toDate();

    const averageWaterLevel = this.operationalInputService
        .calculateAverageWaterLevel(parsedTelegram.sectionOne && parsedTelegram.sectionOne.waterLevelAtTwenty,
          trendResponse && trendResponse.previousWaterLevelAtEight);
    const previousDate = moment(parsedTelegram.sectionZero.date)
        .subtract(1, 'day');

    if (parsedTelegram.sectionOne && parsedTelegram.sectionOne.temperatures) {
      parsedTelegramData.temperatureData = {
        airTemperature: parsedTelegram.sectionOne.temperatures.airTemperature,
        waterTemperature: parsedTelegram.sectionOne.temperatures.waterTemperature,
        telegramDay: parsedTelegram.sectionZero.date
      };
    } else {
      parsedTelegramData.temperatureData = undefined;
    }

    if (parsedTelegram.sectionOne) {
      parsedTelegramData.waterLevelData = {
        averageWaterLevel: parsedTelegram.sectionThree ? 
          parsedTelegram.sectionThree.waterLevelAverage : averageWaterLevel,
        telegramDate: parsedTelegram.sectionZero.date,
        previousDate: previousDate,
        waterLevelAtEight: parsedTelegram.sectionOne.waterLevelAtEight,
        waterLevelAtTwenty: parsedTelegram.sectionOne.waterLevelAtTwenty,
        previousWaterLevelAtEight: trendResponse &&
        trendResponse.previousWaterLevelAtEight,
        previousWaterLevelAtTwenty: parsedTelegram.
            sectionOne.waterLevelAtTwenty,
        validWaterTrend: trendResponse && trendResponse.valid,
        waterLevelTrend: parsedTelegram.sectionOne.waterLevelTrend
      };
    }

    if (parsedTelegram.sectionOne && parsedTelegram.sectionOne.icePhenomenae) {
      parsedTelegramData.icePhenomenaCardData = {
        date: parsedTelegram.sectionZero.date,
        icePhenomenae: parsedTelegram.sectionOne.icePhenomenae,
        disabledDischarge: false
      };
    }

    parsedTelegramData.dischargeData = parsedTelegram.sectionSix;
    parsedTelegramData.meteoData = parsedTelegram.sectionEight;

    const telegramCollectionIndex = this.getTelegramCollectionIndex(parsedTelegramData);
    if (typeof telegramCollectionIndex !== 'undefined') {
      this.parsedTelegramDataCollection[telegramCollectionIndex] = parsedTelegramData;
    } else {
      this.parsedTelegramDataCollection.push(parsedTelegramData);
    }

    //last iteration 
   
    if ((promiseIndex || promiseIndex === 0) && promiseIndex === (this.stationAndTrendDataPromises.length - 1)) {
      this.notifyChanges(); 
    }

  }

  private getTelegramCollectionIndex(parsedTelegram: IParsedTelegramData) {
    let telegramIndex: number;
    angular.forEach(this.parsedTelegramDataCollection, (telegramData, index) => {
      if (telegramData.telegramText === parsedTelegram.telegramText) {
        telegramIndex = index;
      }
    });

    return telegramIndex;
  }

  public onInitialTelegramInputChange() {
    if (this.telegrams) {
      this.unprocessedTelegrams = 
        this.telegrams
          .split(/(?:\s\s+|\t)|[\n\r]/g);
    } else {
      this.unprocessedTelegrams = [];
    }

    this.telegrams = '';
     
    this.$timeout(() => {
      angular.forEach(this.telegramForm.$error.kn15Parser, function(field) {
        field.$setTouched();
      });
    });
  }

  public onAddSingleTelegram() {
    this.unprocessedTelegrams.push('');
  }

  public onDeleteTelegramClick(telegramText: string, $index: number) {  
    this.unprocessedTelegrams.splice(this.unprocessedTelegrams.indexOf(telegramText), 1);
    this.telegramsBackendErrorMessages.splice($index, 1);
    this.telegramsMeteoWarningMessages.splice($index, 1);
    if (this.unprocessedTelegrams.length === 0 || !this.telegramForm.$valid) {
      this.processTelegrams();
    }
  } 
  
  /**
   * Force the parse error to be displayed if the URL changed.
   */
  private displayError(index: number) {
    if (this.telegrams && this.telegramForm) {
      this.telegramForm['telegram' + index].$setDirty();
      this.telegramForm['telegram' + index].$setTouched();
    }
  }


  /**
   * Notifies the parent component with the current processed data.
   */
  private notifyChanges() {
    if (this.onProcessed) {
      this.onProcessed({
        parsedTelegramDataCollection: this.parsedTelegramDataCollection,
        unprocessedTelegrams: this.unprocessedTelegrams
      });
    }
  }
}



/** WEBPACK FOOTER **
 ** ./app/operational/input/telegram.controller.ts
 **/